import { render, staticRenderFns } from "./RenameProject.vue?vue&type=template&id=40ecf92c&scoped=true"
import script from "./RenameProject.vue?vue&type=script&lang=js"
export * from "./RenameProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ecf92c",
  null
  
)

export default component.exports